import * as actionTypes from '../../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  company: [],
  form: [],
  levelGroup: [],
  org: [],
  position: [],
  emp: [],
  appraisalType: [],
  report: null,
  loadingStates: []
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'company_id'] }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    message: action.errorMessage
  }
}

const fetchFormStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'form_id'] }
}

const fetchFormSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'form_id'),
    form: action.data
  }
}

const fetchFormFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'form_id'),
    message: action.errorMessage
  }
}

const fetchLevelGroupFilterAppraisalStart = (state, action) => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'level_group_id']
  }
}

const fetchLevelGroupFilterAppraisalSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'level_group_id'),
    levelGroup: action.data
  }
}

const fetchLevelGroupFilterAppraisalFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'level_group_id'),
    message: action.errorMessage
  }
}

const fetchOrgStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'org_id'] }
}

const fetchOrgSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id'),
    org: action.data
  }
}

const fetchOrgFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id'),
    message: action.errorMessage
  }
}

const fetchPositionStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'position_id'] }
}

const fetchPositionSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_id'),
    position: action.data
  }
}

const fetchPositionFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_id'),
    message: action.errorMessage
  }
}

const fetchEmpStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'emp_id'] }
}

const fetchEmpSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_id'),
    emp: action.data
  }
}

const fetchEmpFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_id'),
    message: action.errorMessage
  }
}

const fetchAppTypeStart = (state, action) => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'appraisal_type_id']
  }
}

const fetchAppTypeSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_type_id'),
    appraisalType: action.data
  }
}

const fetchAppTypeFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_type_id')
  }
}

const reportAppraisalSummary = (state, action) => {
  return {
    ...state,
    loading: false,
    report: action.data
  }
}

const reportAppraisalSummaryStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const reportAppraisalSummaryFailed = (state, action) => {
  return { ...state, loading: false }
}

const clearReportAppraisalSummary = (state, action) => {
  return {
    ...state,
    report: null
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_START:
      return fetchFormStart(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchFormSuccess(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchFormFailed(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START:
      return fetchOrgStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchOrgSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchOrgFailed(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_START:
      return fetchPositionStart(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchPositionSuccess(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchPositionFailed(state, action)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_START:
      return fetchEmpStart(state, action)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchEmpSuccess(state, action)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchEmpFailed(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_START:
      return fetchAppTypeStart(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS:
      return fetchAppTypeSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FAILED:
      return fetchAppTypeFailed(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_START:
      return fetchLevelGroupFilterAppraisalStart(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchLevelGroupFilterAppraisalSuccess(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchLevelGroupFilterAppraisalFailed(state, action)
    case actionTypes.REPORT_APPRASAL_SUMMARY_START:
      return reportAppraisalSummaryStart(state, action)
    case actionTypes.REPORT_APPRASAL_SUMMARY_SUCCESS:
      return reportAppraisalSummary(state, action)
    case actionTypes.REPORT_APPRASAL_SUMMARY_FAILED:
      return reportAppraisalSummaryFailed(state, action)
    case actionTypes.CLEAR_REPORT_APPRASAL_SUMMARY:
      return clearReportAppraisalSummary(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }

    default:
      return state
  }
}

export default reducer
